import { render, staticRenderFns } from "./login-input.vue?vue&type=template&id=2ded2f5d&scoped=true&"
import script from "./login-input.vue?vue&type=script&lang=js&"
export * from "./login-input.vue?vue&type=script&lang=js&"
import style0 from "./login-input.vue?vue&type=style&index=0&id=2ded2f5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded2f5d",
  null
  
)

export default component.exports